import Vue from "vue";
import VueI18n from "vue-i18n";
import ElementLocale from "element-ui/lib/locale";
import elementZhCN from "element-ui/lib/locale/lang/zh-CN";
import elementZhTW from "element-ui/lib/locale/lang/zh-TW";
import elementEn from "element-ui/lib/locale/lang/en";
import { Locale as VantLocale } from "vant";
import vantZhCN from "vant/es/locale/lang/zh-CN";
import vantZhTW from "vant/es/locale/lang/zh-TW";
import vantEnUS from "vant/es/locale/lang/en-US";
import zhCN from "./locales/zh-CN";
import zhTW from "./locales/zh-TW";
import en from "./locales/en";

Vue.use(VueI18n);

export const LOCALE_STORAGE_KEY = "app-locale";
export const SUPPORTED_LOCALES = ["zh-CN", "zh-TW", "en"];

const messages = {
  "zh-CN": zhCN,
  "zh-TW": zhTW,
  en,
};

const elementLocales = {
  "zh-CN": elementZhCN,
  "zh-TW": elementZhTW,
  en: elementEn,
};

const vantLocales = {
  "zh-CN": { key: "zh-CN", messages: vantZhCN },
  "zh-TW": { key: "zh-TW", messages: vantZhTW },
  en: { key: "en-US", messages: vantEnUS },
};

function detectLocale() {
  const lang = (navigator.language || "zh-CN").toLowerCase();
  if (lang.includes("tw") || lang.includes("hk") || lang.includes("hant")) {
    return "zh-TW";
  }
  if (lang.startsWith("zh")) {
    return "zh-CN";
  }
  if (lang.startsWith("en")) {
    return "en";
  }
  return "zh-CN";
}

export function getStoredLocale() {
  const saved = window.localStorage.getItem(LOCALE_STORAGE_KEY);
  return SUPPORTED_LOCALES.includes(saved) ? saved : detectLocale();
}

export function setElementLocale(locale) {
  ElementLocale.use(elementLocales[locale] || elementZhCN);
}

export function setVantLocale(locale) {
  const pack = vantLocales[locale] || vantLocales["zh-CN"];
  VantLocale.use(pack.key, pack.messages);
}

const initialLocale = getStoredLocale();
setElementLocale(initialLocale);
setVantLocale(initialLocale);

const i18n = new VueI18n({
  locale: initialLocale,
  fallbackLocale: "zh-CN",
  messages,
});

export function setLocale(locale) {
  if (!SUPPORTED_LOCALES.includes(locale)) {
    return;
  }
  i18n.locale = locale;
  window.localStorage.setItem(LOCALE_STORAGE_KEY, locale);
  setElementLocale(locale);
  setVantLocale(locale);
  document.documentElement.setAttribute("lang", locale);
}

document.documentElement.setAttribute("lang", initialLocale);

export default i18n;
